import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { OpenAPIService } from '../../services/openAPI.service';

import * as _ from 'lodash';

@Component({
  selector: 'medical-photo-evaluation',
  templateUrl: './medical-photo-evaluation.component.html',
  styleUrls: [
    './medical-photo-evaluation.component.scss'
  ]
})
export class MedicalPhotoEvaluationComponent implements OnInit {

  @Input() id: any = null;
  @Input() positionTypes: any = {};

  @Output() onClick = new EventEmitter<any>();

  photo: any = null;

  spin: boolean = false;

  imageUrl: string | null = null;

  aiEvaluationMap: any = null;
  modelEvaluationMap: any = null;

  _hasManualEvaluation: boolean = false;

  constructor(
    private translate: TranslateService,
    private apiService: OpenAPIService
  ) { }

  ngOnInit() {
    this._loadMedicalPhoto(this.id);
  }

  _onClick() {
    this.onClick.emit(this.photo);
  }

  _loadMedicalPhoto(id: number) {
    this.spin = true;
    // this.patientsService.getMedicalPhoto(id).pipe(first()).subscribe(
    this.apiService.getDetails('medicalphotos', id).subscribe({
      next: (response: any) => {
        this.photo = { ...response.data };
        const _mimeType = this.photo.mime_type || 'image/jpeg';
        this.imageUrl = `data:${_mimeType};base64,${this.photo.image}`;
        this._hasManualEvaluation = this._isManualEvaluation();
        this._updateModel();
        this.spin = false;
      },
      error: (error: any) => {
        console.log('_loadMedicalPhoto error', error);
        this.spin = false;
      }
    });
  }

  newModelEvaluationMap: any = {};

  _updateModel() {
    if (this.photo.ai_result && this.photo.ai_result.evaluation_map) {
      this.aiEvaluationMap = { ...this.photo.ai_result.evaluation_map };
      this.modelEvaluationMap = { ...this.photo.manual_evaluation.evaluation_map };

      this.positionTypes[this.photo.type].forEach((item: any) => {
        if (!this.newModelEvaluationMap[item.position]) {
          this.newModelEvaluationMap[item.position] = {
            value: 0,
            position: `null_null_null`
          };
        }
      });
      // Update values
      Object.keys(this.newModelEvaluationMap).forEach((key) => {
        if (this.modelEvaluationMap[key]) {
          this.newModelEvaluationMap[key] = this.modelEvaluationMap[key];
        }
      });
      this.modelEvaluationMap = { ...this.newModelEvaluationMap };
    } else {
      // console.log('NO evaluation_map');
    }
  }
  
  _isManualEvaluation() {
    if (this.photo) {
      return (this.photo.manual_evaluation !== null);
    }
    return false;
  }

  isNotReady() {
    return this.photo && this.photo.photo_status === 'not_ready';
  }

  hasEvaluation() {
    if (this.photo && this.photo.ai_result && this.photo.ai_result.evaluation_map) {
      return !_.isEmpty(this.photo.ai_result.evaluation_map);
    }
    return this._hasManualEvaluation || this.photo.manual_evaluation;
  }

  getPhotoColor(photo: any) {
    if (photo) {
      switch (photo.photo_status) {
        case 'not_ready':
          return 'medium';
        case 'ready':
          return 'primary';
        case 'processing':
          return 'warning';
        case 'processed':
          return 'primary';
        default:
      }
    }
    return 'medium';
  }

  _sendManualEvaluation(form: NgForm) {
    // let _body: any = { ...this.photo.ai_result };
    // _body.evaluation_map = this._modelEvaluationMap;
    // this.patientsService.updateManualEvaluation(_body, this.id).subscribe(
    //   (response: any) => {
    //     this.photo = { ...response.data };
    //     this._hasManualEvaluation = this._isManualEvaluation();
    //   },
    //   (error: any) => {
    //     console.log('_sendManualEvaluation error', error);
    //   }
    // );
    // this._hasManualEvaluation = true;
  }
}
